const bxfArrowRight = {
    svg: '<svg style="width:1.13rem; height:1.13rem;" viewBox="0 0 18 18"><path d="M12.386 9.597 7.604 14.38a.84.84 0 0 1-1.192 0l-.794-.795a.84.84 0 0 1 0-1.192l3.389-3.389-3.389-3.389a.84.84 0 0 1 0-1.192l.791-.801a.84.84 0 0 1 1.192 0l4.781 4.781c.334.33.334.865.004 1.195" clip-rule="evenodd"/></svg>',
};

export { bxfArrowRight as default };
